import { Caption, Image } from '@collab/atoms';
import { Tab, TabContainer } from '@collab/molecules';

const ColorDonut: React.FC = () => (
  <>
    <TabContainer headerBg="primary">
      <Tab title="Light UI">
        <Image
          alt="Light theme donut (without toggle UI)"
          src="/images/components/colour/donut-light.svg"
          aspectRatio={[1, 1]}
          extend={{
            marginTop: 0,
          }}
        />
      </Tab>
      <Tab title="Dark UI">
        <Image
          alt="Dark theme donut (without toggle UI)"
          src="/images/components/colour/donut-dark.svg"
          aspectRatio={[1, 1]}
          extend={{
            marginTop: 0,
          }}
        />
      </Tab>
    </TabContainer>
    <Caption>
      These proportions help clarify how often each colour occurs across both UI
      themes.
    </Caption>
  </>
);
export default ColorDonut;
